import { startOfMinute as startOfMinuteFns } from 'date-fns';

export default function startOfMinute(date: Date): Date {
  return startOfMinuteFns(date);
}
